<template>
	<v-sheet elevation="0">
		<CommonFlame :title="title" :maxWidth="'auto'">
			<v-row no-gutters justify="end">
				<v-btn class="mt-4" color="secondary" :disabled="!valid" @click="submitForm('draft')">
					<v-icon class="mr-1">mdi-content-save-outline</v-icon> 下書き保存
				</v-btn>
				<v-btn class="ml-2 mt-4" color="secondary" :disabled="!valid" @click="openConfirmDialog">
					<v-icon class="mr-1">mdi-check</v-icon> 保存して承認依頼
				</v-btn>
				<v-btn class="ml-2 mt-4" color="secondary" :disabled="!valid" @click="openMatterDialog">
					<v-icon class="mr-1">mdi-file-document-outline</v-icon> 案件確認
				</v-btn>
				<v-btn
					class="ml-2 mt-4"
					color="secondary"
					:disabled="!valid"
					@click="openRequirementDialog"
				>
					<v-icon class="mr-1">mdi-file-document-outline</v-icon> 依頼確認
				</v-btn>
				<v-btn class="ml-2 mt-4" color="secondary" :disabled="!valid" @click="openAnswerDialog">
					<v-icon class="mr-1">mdi-file-document-outline</v-icon> 施工法検討依頼回答確認
				</v-btn>
			</v-row>
			<v-form ref="form" v-model="valid">
				<ConstructionCostArea :costItems="costItems" :isActual="isActual" :isShow="isShow" />
			</v-form>
		</CommonFlame>
	</v-sheet>
</template>

<script>
import axios from "axios"
import authenticate from "../../helper/authenticate"
import errorHandling from "../../helper/errorHandling"
import rules from "../../helper/rules"

import CommonFlame from "../shared/CommonFlame.vue"
import ShowDetailRecord from "../shared/ShowDetailRecord.vue"
import ConstructionCostArea from "./components/ConstructionCostArea.vue"

export default {
	components: {
		CommonFlame,
		ShowDetailRecord,
		ConstructionCostArea,
	},
	data() {
		return {
			title: "原価計算",
			construction: {},
			matter: {},
			confirmDialog: false,
			matterDialog: false,
			requirementDialog: false,
			answerDialog: false,
			valid: false,
			costType: "budget",
			errors: [],
			costItems: sampleCostItems(),
			rules,
			isActual: false,
			isShow: false,
		}
	},
	mounted() {
		this.fetchCost()
		if (this.$route.query.cost_type == "actual") {
			this.costType = "actual"
			this.isActual = true
		}
	},
	methods: {
		fetchCost() {
			const headers = authenticate.setHeader()
			const url = `/erp/v1/constructions/costs/${this.$route.params.id}/edit`
			const params = { cost_type: this.costType }
			axios
				.get(url, { headers, params })
				.then((res) => {
					this.requirement = res.data.requirement
					this.matter = res.data.matter
				})
				.catch((err) => {
					errorHandling.errorResponse(err)
				})
		},
		openConfirmDialog() {
			this.confirmDialog = true
		},
		openMatterDialog() {
			this.matterDialog = true
		},
		openRequirementDialog() {
			this.requirementDialog = true
		},
		openAnswerDialog() {
			this.answerDialog = true
		},
		submitForm(status) {
			// TODO Formにする必要あり
			const headers = authenticate.setHeader()
			const params = {}
			const url = `/erp/v1/constructions/requirements/${this.$route.params.id}/costs`
			axios
				.post(url, params, {
					headers,
				})
				.then((res) => {
					this.$store.dispatch("setFlash", {
						type: "notice",
						text: "",
					})
					this.$router.push({ name: "" })
				})
				.catch((err) => {
					const errors = errorHandling.errorResponse(err)
					if (Array.isArray(errors)) {
						this.errors = errors
					}
				})
		},
	},
	computed: {
		// 合計工数
		totalDays() {
			return (type, dayType) => {
				// type = employee or outsource
				// dayType = all or weekday or weekend
				// dayTypeをとtypeを使って、合計算出
				switch (dayType) {
					case "all":
						return 0
					case "weekday":
						return 0
					case "weekend":
						return 0
				}
			}
		},
		// 日毎の工数
		totalByDays() {
			return (day, type) => {
				return 0
			}
		},
	},
}

function sampleCostItems() {
	const defaultColumn = [
		{
			name: "項目",
			width: 200,
			input: true,
			onlyBudget: true,
		},
		{
			name: "種類",
			width: 120,
			input: true,
			onlyBudget: true,
		},
		{
			name: "寸法・仕様",
			width: 100,
			input: true,
			onlyBudget: true,
		},
		{
			name: "数量",
			width: 80,
			input: true,
		},
		{
			name: "単位",
			width: 80,
			input: true,
			onlyBudget: true,
		},
		{
			name: "単価",
			width: 100,
			input: true,
		},
		{
			name: "金額",
			width: 100,
			input: false,
		},
		{
			name: "資材管理費",
			width: 100,
			input: true,
		},
		{
			name: "工場間接費",
			width: 100,
			input: false,
		},
		{
			name: "工場原価",
			width: 100,
			input: true,
		},
		{
			name: "販管費",
			width: 100,
			input: false,
		},
		{
			name: "総原価",
			width: 100,
			input: false,
		},
		{
			name: "外部費用",
			width: 100,
			input: true,
		},
	]
	return [
		{
			name: "ゴム材料",
			columns: defaultColumn,
		},
		{
			name: "液状ゴム",
			columns: defaultColumn,
		},
		{
			name: "接着剤",
			columns: defaultColumn,
		},
		{
			name: "コート",
			columns: defaultColumn,
		},
		{
			name: "リース・消耗品(日数なし)",
			columns: defaultColumn,
		},
		{
			name: "リース・消耗品(日数あり)",
			columns: [
				{
					name: "項目",
					width: 200,
					input: true,
					onlyBudget: true,
				},
				{
					name: "種類",
					width: 120,
					input: true,
					onlyBudget: true,
				},
				{
					name: "寸法・仕様",
					width: 100,
					input: true,
					onlyBudget: true,
				},
				{
					name: "数量",
					width: 80,
					input: true,
				},
				{
					name: "単位",
					width: 80,
					input: true,
					onlyBudget: true,
				},
				{
					name: "単価",
					width: 100,
					input: true,
				},
				{
					name: "日数",
					width: 100,
					input: true,
				},
				{
					name: "金額",
					width: 100,
					input: false,
				},
				{
					name: "運送費",
					width: 100,
					input: true,
				},
				{
					name: "資材管理費",
					width: 100,
					input: true,
				},
				{
					name: "工場間接費",
					width: 100,
					input: false,
				},
				{
					name: "工場原価",
					width: 100,
					input: true,
				},
				{
					name: "販管費",
					width: 100,
					input: false,
				},
				{
					name: "総原価",
					width: 100,
					input: false,
				},
				{
					name: "外部費用",
					width: 100,
					input: false,
				},
				{
					name: "備考",
					width: 200,
					input: true,
				},
			],
		},
		{
			name: "人件費",
			columns: defaultColumn,
		},
		{
			name: "宿泊費",
			columns: defaultColumn,
		},
		{
			name: "輸送費",
			columns: defaultColumn,
		},
		{
			name: "交通費",
			columns: defaultColumn,
		},
	]
}
</script>
